var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-ali-jus-center-dir-column m-top-2rem"},[_c('p',{staticClass:"co-brown"},[_vm._v("- Share This News -")]),_c('div',{staticClass:"m-top-05rem"},[_c('a',{staticClass:"twitter-share-button",attrs:{"href":"https://twitter.com/share?ref_src=twsrc%5Etfw","data-show-count":"false"}},[_vm._v("Tweet")])])])
}]

export { render, staticRenderFns }